export const SET_CANCELLATION = 'SET_CANCELLATION'
export const RESET_CANCELLATION = 'RESET_CANCELLATION'
